export default __webpack_public_path__ + "static/media/image2.e605044d.jpg";